import { REGIONS, REGIONS_CURRENCY_SYMBOLS } from 'app/lib/constants'
import { getApplicationConfig } from 'config'

const config = getApplicationConfig()

export const isRegion = (region: REGIONS) => config.region === region

export const getCurrencySymbol = () => REGIONS_CURRENCY_SYMBOLS[config.region]
